import { j as H } from "./jsx-runtime-3tyXYecC.mjs";
import { _ as S } from "./composeRefs-YONvD-rx.mjs";
import { C as A } from "./currency-field-DnYDcx0r.mjs";
import { a as B } from "./add-rhf-default-error-message-C9MkLfg3.mjs";
import { g as Q } from "./get-aria-describedby-G1wcWKF2.mjs";
import { u as M } from "./use-rhf-wrapper-controller-DGFm3TD5.mjs";
import { t as V } from "./toggle-rhf-rules-Z1TdwfO9.mjs";
import { c as y } from "./combine-function-calls-C5qD-ZYI.mjs";
const n = {
  max: window.jQuery ? $._("This amount exceeds the maximum") : "This amount exceeds the maximum",
  min: window.jQuery ? $._("This amount is below the minumum") : "This amount is below the minumum",
  required: window.jQuery ? $._("Please enter an amount") : "Please enter an amount"
}, G = (s) => typeof s == "string" ? {
  message: s || n.required,
  value: !0
} : B(s, n.required);
function N({
  apiRef: s,
  ariaDescribedby: l,
  control: F,
  defaultValue: R = {},
  disabled: f,
  errorMessageId: c,
  max: t,
  min: r,
  name: p,
  onBlur: h,
  onChange: b,
  required: d,
  shouldUnregister: j,
  status: C,
  validate: i,
  ...w
}) {
  var g;
  const _ = {
    max: (e) => {
      let o = typeof t == "object" && "value" in t ? t.value : t;
      if (o !== void 0 && (e == null ? void 0 : e.amount) !== void 0) {
        const a = parseFloat((e == null ? void 0 : e.amount) || ""), u = typeof t == "object" && "message" in t ? t.message : n.max;
        return typeof o == "string" && (o = parseFloat(o)), a <= o || u;
      }
    },
    min: (e) => {
      let o = typeof r == "object" && "value" in r ? r.value : r;
      if (o !== void 0 && (e == null ? void 0 : e.amount) !== void 0) {
        const a = parseFloat((e == null ? void 0 : e.amount) || ""), u = typeof r == "object" && "message" in r ? r.message : n.min;
        return typeof o == "string" && (o = parseFloat(o)), a >= o || u;
      }
    },
    required: (e) => {
      const o = G(d);
      if (o.value)
        return !!(e != null && e.amount) || o.message;
    },
    ...typeof i == "function" ? { custom: i } : i
  }, { field: x, fieldState: m } = M({
    control: F,
    defaultValue: R,
    name: p,
    rules: V({ validate: _ }, f),
    shouldUnregister: j
  }), { onBlur: E, onChange: T, ref: q, value: D } = x;
  return /* @__PURE__ */ H.jsx(
    A,
    {
      ...w,
      ariaDescribedby: Q(m.error ? c : void 0, l),
      disabled: f,
      errorMessage: c || (g = m.error) == null ? void 0 : g.message,
      name: p,
      onBlur: y(E, h),
      onChange: y(T, b),
      ref: S(q, s),
      required: !!d,
      status: m.error ? "error" : C,
      value: D
    }
  );
}
export {
  N as C
};
//# sourceMappingURL=currency-field-rhf-Dy6BYAnr.mjs.map
